import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Fatal Application Crash:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-vh-100 d-flex flex-column align-items-center justify-content-center" style={{ backgroundColor: 'var(--up-bg)', color: 'var(--up-ink)' }}>
          <h1 className="display-4 fw-bold text-danger mb-3">System Malfunction</h1>
          <p className="lead" style={{ color: 'var(--up-ink-soft)' }}>
            {this.state.error?.message || 'A critical rendering error occurred.'}
          </p>
          <button 
            className="btn mt-4 px-4 py-2"
            style={{ backgroundColor: 'var(--up-primary)', color: '#fff', borderRadius: 'var(--up-radius-pill)' }}
            onClick={() => window.location.reload()}
          >
            Reboot Application
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
